import { Button } from '@/features/button';
import ErrorContent from '@/app/(error-pages)/error-content';
interface Props {
  refetch: () => void;
}
export default function TimeoutError({
  refetch
}: Props) {
  return <>
            <ErrorContent statusCode='default' data-sentry-element="ErrorContent" data-sentry-source-file="timeout-error.tsx" />
            <div className='fixed bottom-0 left-0 w-full p-4 lg:bottom-11 lg:left-1/2 lg:w-[344px] lg:-translate-x-1/2 lg:p-0'>
                <Button graphicStyle='outlined' size='large' className='w-full' onClick={() => refetch()} data-sentry-element="Button" data-sentry-source-file="timeout-error.tsx">
                    تلاش مجدد
                </Button>
            </div>
        </>;
}